export const getters = {
  // Wallet and authentication
  signInfo: (state) => state.signInfo,
  isAuthenticated: (state) => state.isAuthenticated,
  isConnected: (state) => state.isConnected,
  accounts: (state) => state.accounts,
  connectingMetaKeep: (state) => state.connectingMetaKeep,
  isLogging: (state) => state.isLogging,

  // Web3Auth
  web3auth: (state) => state.web3auth,
  walletServicesPlugin: (state) => state.walletServicesPlugin,

  // Network
  networkId: (state) => state.networkId,
  networkName: (state) => state.networkName,
  requiredNetworkName: (state) => state.requiredNetworkName,

  // Projects and offerings
  projects: (state) => state.projects,
  createdOffering: (state) => state.createdOffering,
  createdProject: (state) => state.createdProject,
  offeringState: (state) => state.offeringState,
  allocatedOfferings: (state) => state.allocatedOfferings,

  // Balances and financial data
  bctBalance: (state) => state.bctBalance,
  usdcBalance: (state) => state.usdcBalance,
  remainingAllocation: (state) => state.remainingAllocation,
  balances: (state) => state.balances,
  gasPrice: (state) => state.gasPrice,

  // Commission data
  carbonCreditCommission: (state) => state.carbonCreditCommission,
  usdCommission: (state) => state.usdCommission,
  carbonCreditCommissionsTransferred: (state) => state.carbonCreditCommissionsTransferred,
  usdCommissionTransferred: (state) => state.usdCommissionTransferred,
  commissionWithdrawn: (state) => state.commissionWithdrawn,
  developerCommissionTransfered: (state) => state.developerCommissionTransfered,
  developerCarbonCreditCommissionsTransferred: (state) => state.developerCarbonCreditCommissionsTransferred,

  // Transaction results
  approvalResult: (state) => state.approvalResult,
  bidResult: (state) => state.bidResult,
  txUrl: (state) => state.txUrl,
  withdrawResult: (state) => state.withdrawResult,
  userWithdrawTxUrl: (state) => state.userWithdrawTxUrl,

  // Withdrawal and funds
  fundsPaid: (state) => state.fundsPaid,
  potentialRefund: (state) => state.potentialRefund,
  isCancelled: (state) => state.isCancelled,
  couldWithdrawingBackFunds: (state) => state.couldWithdrawingBackFunds,
  isEligibleForWithdrawingBackFunds: (state) => state.isEligibleForWithdrawingBackFunds,
  nextUnlockTime: (state) => state.nextUnlockTime,
  listingEnd: (state) => state.listingEnd,
  paymentSlices: (state) => state.paymentSlices,
  fundsCollected: (state) => state.fundsCollected,
  currentPaymentSlice: (state) => state.currentPaymentSlice,

  // Dynamic getter for remaining funds
  getRemainingFundsUnlockedByKey: (state) => (key) => {
    if (!Object.prototype.hasOwnProperty.call(state.remainingFundsUnlocked, key)) {
      return undefined;
    }
    return state.remainingFundsUnlocked[key];
  },

  // AML and audit
  auditWindowOpen: (state) => state.auditWindowOpen,
  unsuccessfulAudit: (state) => state.unsuccessfulAudit,
  successfulAudit: (state) => state.successfulAudit,
  auditPeriod: (state) => state.auditPeriod,

  // Error handling
  walletErrorMessage: (state) => state.walletErrorMessage,

  // Admin and roles
  adminRole: (state) => state.adminRole,

  // Developer tokens
  developerTokensBurned: (state) => state.developerTokensBurned
};
